import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import encumbrancesExcelModalSteps from '../constants/encumbrancesExcelModalSteps';
import { useEncumbrancesExcelModal } from '../context/EncumbrancesExcelModalContext';

const EncumbrancesExcelModalHeader: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useEncumbrancesExcelModal();

  const isPreviewStep = data.step === encumbrancesExcelModalSteps.PREVIEW;
  const isImportingStep = data.step === encumbrancesExcelModalSteps.IMPORTING;

  const getSubtitle = () => {
    if (isImportingStep) {
      return t('EncumbrancesExcelImportDoNotClose');
    }

    if (isPreviewStep) {
      return t('EncumbrancesExcelPreviewSubtitle');
    }

    return t('EncumbrancesExcelUploadSubtitle');
  };

  const renderStepPill = (
    stepNumber: number,
    label: string,
    isActive: boolean
  ) => (
    <span
      className={`badge ${isActive ? 'badge-primary' : 'badge-dim badge-outline-light'}`}
      data-testid={`encumbrances-excel-step-pill-${stepNumber}`}
    >
      {stepNumber}. {label}
    </span>
  );

  return (
    <Modal.Header className="encumbrances-excel-modal__header">
      <div className="d-flex flex-column flex-grow-1">
        <h5 className="modal-title mb-1">
          {isImportingStep
            ? t('EncumbrancesExcelImportInProgress')
            : t('UploadEncumbrances')}
        </h5>
        <p className="text-soft small mb-0">{getSubtitle()}</p>
      </div>

      <div className="d-flex align-items-center">
        <div className="encumbrances-excel-modal__step-pills d-none d-md-flex">
          {renderStepPill(
            1,
            t('EncumbrancesExcelStepUpload'),
            !isPreviewStep
          )}
          {renderStepPill(
            2,
            t('EncumbrancesExcelStepReview'),
            isPreviewStep
          )}
        </div>

        <a
          className={`close cursor-pointer ${isImportingStep ? 'disabled opacity-50' : ''}`}
          onClick={isImportingStep ? undefined : actions.handleCloseModal}
          aria-disabled={isImportingStep}
          data-testid="encumbrances-excel-close-button"
        >
          <em className="icon ni ni-cross" />
        </a>
      </div>
    </Modal.Header>
  );
};

export default EncumbrancesExcelModalHeader;
